<template>
    <article
        class="flex flex-col col-span-full first:!col-start-1 group"
        :class="{'md:col-span-6': size === 'lg', 'md:col-span-4': size === 'md', 'col-span-full md:!col-start-1 md:col-end-13': size === 'sm'}"
    >
        <NuxtLink :to="`/insights/${post.data.slug}`">
            <div
                :class="size === 'sm'
                    ? 'grid grid-cols-3 md:grid-cols-12 gap-4'
                    : size === 'md'
                        ? 'grid grid-cols-3 md:grid-cols-12 gap-4 md:contents'
                        : 'contents'"
            >
                <div class="relative w-full aspect-video overflow-hidden rounded-md object-cover !col-start-1 self-center" :class="{'col-span-1 md:col-span-3': size === 'sm' || size === 'md'}">
                    <img :src="`/api/files/image/${post.data['hero-image']}`" class="w-full h-full absolute top-1/2 right-0 bottom-0 left-1/2 -translate-y-1/2 -translate-x-1/2 object-cover transition-transform duration-200 ease-out group-hover:scale-105" />

                </div>
                <div :class="{'col-span-2 md:col-span-9 gap-y-0': size === 'sm' || size === 'md'}" class="flex flex-col grow gap-2">
                    <div class="flex gap-2 text-dark-blue/50">
                        <time
                            class="uppercase"
                            :datetime="publicationDate ?? undefined"
                        >{{ format_date(publicationDate ?? post._versioning.updated) }}</time>
                        <div>·</div>
                        <div class="uppercase ">READING TIME</div>
                        <div class="font-semibold">{{getLocalizedValue(post.data._computed.readingTime).minutes}} MIN</div>
                    </div>
                    <h3 class="view-h3 max-w-3xl leading-[1.2] mb-2">
                        {{ getPostTitle(post) }}
                    </h3>
                    <ContentReference
                        source-bucket="blog"
                        :source-data="post.data"
                        field-path="author"
                        v-slot="{ label, image }"
                    >
                        <div v-if="label" class="mt-auto flex items-center gap-2">
                            <img
                                v-if="image"
                                :src="`/api/files/image/${image}?size=thumb`"
                                :alt="label"
                                class="size-8 rounded-full object-cover"
                            />
                            <div>{{t('author-prefix')}} {{ label }}</div>
                        </div>
                    </ContentReference>

                </div>
            </div>
            <div
                class="h-[1px] w-full bg-dark-blue/50 my-8"
                :class="{'md:hidden' : size !== 'sm'}"
            />

        </NuxtLink>
    </article>
</template>

<script setup lang="ts">
import type { BucketData } from "#layers/cms/shared/types/bucketData"
const { get_value: getLocalizedValue } = useLocalizedValue()
const {format_date} = useTextUtils()

const { t } = useI18n({useScope: 'local'})

const { post } = defineProps({
    post: {
        type: Object as PropType<BucketData>,
        required: true
    },
    size: String as PropType<'lg' | 'md' | 'sm'>,
})

const publicationDate = typeof post.data.date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(post.data.date)
    ? post.data.date
    : null

const getPostTitle = (post: BucketData) => {
    return getLocalizedValue<string>(
        post.data?.title,
    )
}

</script>

<i18n lang="yaml">
en:
    author-prefix: By
nl:
    author-prefix: Door
</i18n>
